module.exports = __webpack_public_path__ + "static/media/new-year-title.a4492383.png";